import de from './de';
import en from './en';

export default {
	de: de,
	en: en,
};
